module.exports = __webpack_public_path__ + "static/media/call_type_decision.c76c8a85.svg";